@let backgroundClasses = "bg-gray-light drop-shadow-custom rounded-2xl px-5 py-3.5";
@let noBackgroundClasses = "p-2.5 text-white";

<div class="group relative block size-full select-none overflow-hidden rounded-3xl">
  @if (image(); as image) {
    <app-image
      [hoverEffect]="true"
      [image]="image"
      [isPriority]="isPriority()"
      [pregenerationSize]="{ width: 350, height: 296 }" />
  }
  <div class="absolute inset-0 m-2.5 flex flex-col">
    <div
      (click)="imageClicked.emit()"
      [class.cursor-pointer]="imageCursorType() === 'pointer'"
      [class.cursor-zoom-in]="imageCursorType() === 'zoomIn'"
      class="relative flex flex-1 items-center justify-center">
      <ng-content select="[card-overlay-center]" />

      <div class="absolute bottom-0">
        <ng-content select="[card-overlay-bottom]" />
      </div>
    </div>
    <div [class]="hasBackground() ? backgroundClasses : noBackgroundClasses" class="flex flex-col">
      <div class="flex items-center justify-between gap-x-5 text-sm">
        <ng-content select="[card-subtitle-left]" />
        <ng-content select="[card-subtitle-right]" />
      </div>
      <div class="flex items-center justify-between gap-x-5 font-bold">
        <ng-content select="[card-title-left]" />
        <ng-content select="[card-title-right]" />
      </div>
      <div class="line-clamp-6 desk:line-clamp-4">
        <ng-content select="[card-description]" />
      </div>
    </div>
  </div>
</div>
